import { createShallowStore, createStore } from '@frontend/store';

type InsuranceTabStore = {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  currentFilterValue: string;
  setCurrentFilterValue: (value: string) => void;
  currentStatusSelection: string;
  setCurrentStatusSelection: (status: string) => void;
  insuranceStatusByPersonIdsMap?: Record<string, string>;
  setInsuranceStatusByPersonIdsMap: (map: Record<string, string>) => void;
  insuranceStatusCounts?: Record<string, number>;
  setInsuranceStatusCounts: (counts: Record<string, number>) => void;
  setRefetchInsuranceStatuses: (refetch: () => void) => void;
  refetchInsuranceStatuses?: () => void;
  isReportOpen: boolean;
  setIsReportOpen: (isOpen: boolean) => void;
};

const useInsuranceTabStore = createStore<InsuranceTabStore>(
  (set) => ({
    isLoading: false,
    currentFilterValue: '',
    insuranceStatusCounts: {},
    currentStatusSelection: '',
    insuranceStatusByPersonIdsMap: {},
    isReportOpen: false,
    setCurrentFilterValue: (value) => set((state) => ({ ...state, currentFilterValue: value })),
    setCurrentStatusSelection: (status) => set((state) => ({ ...state, currentStatusSelection: status })),
    setInsuranceStatusByPersonIdsMap: (map) => set((state) => ({ ...state, insuranceStatusByPersonIdsMap: map })),
    setInsuranceStatusCounts: (counts) => set((state) => ({ ...state, insuranceStatusCounts: counts })),
    setIsLoading: (loading) => set((state) => ({ ...state, isLoading: loading })),
    setRefetchInsuranceStatuses: (refetch) => set((state) => ({ ...state, refetchInsuranceStatuses: refetch })),
    setIsReportOpen: (isOpen) => set((state) => ({ ...state, isReportOpen: isOpen })),
  }),
  {
    name: 'insuranceTabStore',
  }
);

export const useInsuranceTabShallowStore = createShallowStore<InsuranceTabStore>(useInsuranceTabStore);
